import { FilterMenuItemType } from "types";
import styles from "./style.module.scss";
import classNames from "classnames";
import { useFiltersMenu } from "../../../hooks/useFiltersMenu";
import { CustomMetadataField } from "vl-api/vlSchemas";
import VLTooltip from "views/uikit/VLTooltip";

interface SingleOptionProps {
  name: string;
  icon: JSX.Element;
  disabled?: boolean;
  tooltipContent?: string;
  onSelect: () => void;
  className?: string;
}

export const SingleOption = ({
  icon,
  name,
  disabled = false,
  tooltipContent = "",
  onSelect,
  className,
}: SingleOptionProps) => {
  return (
    <VLTooltip title={tooltipContent}>
      <div
        className={classNames(styles.filter, className, {
          [styles.disabled]: !!disabled,
        })}
        onClick={onSelect}
        data-testid={`single-filter-option-${name}`}
      >
        <div className={styles.icon}>{icon}</div>
        <span className={styles.name}>{name}</span>
      </div>
    </VLTooltip>
  );
};

interface FilterMenuProps {
  onSelect: (type: FilterMenuItemType) => void;
  datasetId: string;
  customMetadataData?: CustomMetadataField[] | null;
}

export default function FilterMenu({
  onSelect,
  datasetId,
  customMetadataData,
}: FilterMenuProps) {
  const { activeColumnCount, filterOptions } = useFiltersMenu({
    datasetId,
    onSelect,
    customMetadataData,
  });
  return (
    <div className={styles.filterMenuWrapper}>
      <div
        className={styles.filterMenu}
        data-testid="filter-menu"
        style={{
          gridTemplateColumns: `repeat(${activeColumnCount}, max-content)`,
        }}
      >
        {filterOptions.map((option, index) => {
          return (
            <SingleOption
              key={index}
              {...option}
              onSelect={option.handleSelect}
              className={option.className}
            />
          );
        })}
      </div>
    </div>
  );
}
